import keymirror from 'keymirror';

export default keymirror({
  GET_NUGGETS: null,
  GET_NUGGETS_SUCCESS: null,
  GET_NUGGETS_NEXT_PAGE_SUCCESS: null,
  GET_NUGGETS_ERROR: null,
});
